import { UPDATE_STATUS } from "../Defs/statusdefs";

const initialState = {
  status: "idle", // initial status can be 'idle'
};

const updateStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    default:
      return state;
  }
};

export default updateStatusReducer;
